import Icon from '../components/Icon';
import ImageWrapper from '../components/ImageWrapper';
import alice from '../img/alice.jpg';
import '../index.css';
import useEmblaCarousel from 'embla-carousel-react';
import { useCallback, useEffect } from 'react';
import { DotButton, useDotButton } from './EmblaCarouselDotButton';

function Testimonials() {
    const [emblaRef, emblaApi] = useEmblaCarousel({
        loop: true,
        watchDrag: true,
        breakpoints: {
            '(min-width: 1100px)': { watchDrag: false },
        },
    });

    const { selectedIndex, scrollSnaps, onDotButtonClick } =
        useDotButton(emblaApi);
    useEffect(() => {
        if (emblaApi) {
            console.log(emblaApi.slideNodes()); // Access API
        }
    }, [emblaApi]);
    const scrollPrev = useCallback(() => {
        if (emblaApi) emblaApi.scrollPrev();
    }, [emblaApi]);

    const scrollNext = useCallback(() => {
        if (emblaApi) emblaApi.scrollNext();
    }, [emblaApi]);
    return (
        <div
            className="embla flex flex-col items-center justify-center"
            ref={emblaRef}>
            <div className="embla__container flex items-center gap-8 page_width">
                <div className="flex flex-col items-center embla__slide w-full">
                    <h2 className="w-2/3 lg:w-1/2 text-2xl lg:text-4xl text-center text-white">
                        Couldn’t have dreamed of a better experience! We are
                        incredibly grateful to Smooth Affairs for their
                        exceptional organization and creativity!
                    </h2>
                    <div className="flex items-center mt-8 gap-2">
                        <ImageWrapper
                            src={alice}
                            className="rounded-full w-16 h-16"
                        />
                        <div className="flex flex-col items-start">
                            <h5 className="text-xl">Alice Green</h5>
                            <p className="text-brand">Manchester</p>
                        </div>
                    </div>
                </div>
                <div className="flex flex-col items-center embla__slide w-full">
                    <h2 className="w-2/3 lg:w-1/2 text-2xl lg:text-4xl text-center text-white">
                        Couldn’t have dreamed of a better experience! We are
                        incredibly grateful to Smooth Affairs for their
                        exceptional organization and creativity!
                    </h2>
                    <div className="flex items-center mt-8 gap-2">
                        <ImageWrapper
                            src={alice}
                            className="rounded-full w-16 h-16"
                        />
                        <div className="flex flex-col items-start">
                            <h5 className="text-xl">Alice Green</h5>
                            <p className="text-brand">Manchester</p>
                        </div>
                    </div>
                </div>
                <div className="flex flex-col items-center embla__slide w-full">
                    <h2 className="w-2/3 lg:w-1/2 text-2xl lg:text-4xl text-center text-white">
                        Couldn’t have dreamed of a better experience! We are
                        incredibly grateful to Smooth Affairs for their
                        exceptional organization and creativity!
                    </h2>
                    <div className="flex items-center mt-8 gap-2">
                        <ImageWrapper
                            src={alice}
                            className="rounded-full w-16 h-16"
                        />
                        <div className="flex flex-col items-start">
                            <h5 className="text-xl">Alice Green</h5>
                            <p className="text-brand">Manchester</p>
                        </div>
                    </div>
                </div>
            </div>
            <div className="embla__dots lg:hidden">
                {scrollSnaps.map((_, index) => (
                    <DotButton
                        key={index}
                        onClick={() => onDotButtonClick(index)}
                        className={'embla__dot'.concat(
                            index === selectedIndex
                                ? ' embla__dot--selected'
                                : ''
                        )}
                    />
                ))}
            </div>
            <button
                className="embla__prev absolute hidden lg:block left-40 top-0 bottom-0"
                onClick={scrollPrev}>
                <Icon
                    name="arrow"
                    className="w-8 h-8 text-white rotate-180"
                />
            </button>
            <button
                className="embla__next absolute hidden lg:block right-40 top-0 bottom-0"
                onClick={scrollNext}>
                <Icon
                    name="arrow"
                    className="w-8 h-8 text-white"
                />
            </button>
        </div>
    );
}

export default Testimonials;
